import React, { PureComponent } from 'react';
import { Card, CardBody, Col, ButtonToolbar, Label, Input, Row } from 'reactstrap';
import ProductGallery from '../../../../components/catalog/ProductGallery';
import ProductTabs from './ProductTabs';
import { connect } from 'react-redux';
import { addItem } from '../../../../redux/actions/cartActions';
import { withApollo, Mutation } from 'react-apollo';
import { withRouter } from 'react-router-dom'
import { AddProductToCart } from '../../../../queries/cart'

class ProductCard extends PureComponent {
  state = {
    addedToCart: false,
    quantity: 1
  }

  adjustProductquantity(addedItem) {
    let cartItems = this.props.cartItems;
    return cartItems.map(item => {
      if (item.productID === addedItem[0].productID) {
        return { ...item, quantity: item.quantity + this.state.quantity }
      } else {
        return { ...item, quantity: item.quantity };
      }
    })
  }

  render() {
    let cartItems = this.props.cartItems;

    const { currentProduct } = this.props;

    return (
      <Col md={12} lg={12}>
        {
          currentProduct ?
            <Card>
              <CardBody>
                <div className='product-card'>
                  <ProductGallery images={currentProduct.images.map(image => {
                    return { src: image }
                  })} />
                  <div className='product-card__info'>
                    <Row>
                      <Col>
                        <h3 className='product-card__title' style={{ marginTop: '0', display: 'inline-block' }}>
                          {currentProduct.productName}
                        </h3>
                        <br />
                        {currentProduct.tags.map((tag, i) => {
                          return (
                            <span key={i}>
                              <div className="badge badge-primary tag-badge">
                                {tag}
                              </div>
                              <span>&nbsp;</span>
                            </span>
                          )
                        })}

                      </Col>
                      <Col>
                        <form
                          className='form product-card__form'
                          style={{ marginTop: '0', display: 'inline-block', float: 'right' }}>
                          <ButtonToolbar className='product-card__btn-toolbar'>
                            {
                              this.state.addedToCart ?
                                <p
                                  style={{
                                    fontWeight: 'bold',
                                    padding: 10,
                                    justifyContent: 'center',
                                    alignItems: "center"
                                  }}>Item added!</p>
                                :
                                <Mutation
                                  mutation={AddProductToCart}
                                  onCompleted={(data) => {
                                  }}
                                  onError={(e) => {
                                    console.log(e)
                                  }}
                                >
                                  {(addProductToCart, { loading, data: cartdata, error: cartError }) => {
                                    return (<button onClick={(e) => {
                                      e.preventDefault();
                                      //
                                      let itemsToAdd = []
                                      if (cartItems && cartItems.length > 0) {
                                        itemsToAdd.push(cartItems.find(item => {
                                          return item.productID === currentProduct.productID

                                        }));
                                      }

                                      //if the item already exists
                                      itemsToAdd.length > 0 && itemsToAdd[0] !== undefined ?
                                        cartItems = this.adjustProductquantity(itemsToAdd) :
                                        cartItems.push({
                                          ...currentProduct,
                                          quantity: this.state.quantity
                                        })

                                      //persist cart data to db
                                      let index = null;
                                      if (itemsToAdd.length && itemsToAdd[0] !== undefined) {
                                        let ind = cartItems.find(ct => {
                                          return ct.productID === itemsToAdd[0].productID
                                        })
                                        index = cartItems.indexOf(ind)
                                      }

                                      index = index ? index : cartItems.length - 1

                                      addProductToCart({
                                        variables: {
                                          productId: cartItems[index].productID,
                                          productName: cartItems[index].productName,
                                          productShortDescription: cartItems[index].productShortDescription,
                                          price: Number(cartItems[index].price),
                                          quantity: cartItems[index].quantity,
                                          images: cartItems[index].images,
                                          companyEmail: cartItems[index].companyEmail,
                                          vendorName: cartItems[index].companyName
                                        }
                                      });

                                      //add products to redux state
                                      this.props.addItem(cartItems);

                                      this.setState({ addedToCart: true }, () => {
                                        const self = this;
                                        setTimeout(function () {
                                          self.setState({ addedToCart: false })
                                        }, 2000);
                                      });
                                    }} className='btn btn-primary'>Add to cart</button>)
                                  }}
                                </Mutation>
                            }
                            {/*<Button color='primary'>Add to cart</Button>*/}
                          </ButtonToolbar>
                        </form>
                      </Col>
                    </Row>
                    <Row style={{
                      float: 'right'
                    }}>
                      <Col>
                        <Label>Enter the quantity : </Label>
                        <Input
                          className="quantity-field"
                          type="select"
                          value={this.state.quantity}
                          onChange={(event) => { this.setState({ quantity: Number(event.target.value) }) }}
                          style={{ float: 'right' }}>
                          {[...Array(10)].map((a, i) => {
                            return <option value={i + 1} key={i}>{i + 1}</option>
                          })}
                        </Input>
                      </Col>
                    </Row>
                    <div className='product-card__rate'>
                    </div>
                    <h1 className='product-card__price'>$ {Number(currentProduct.price).toFixed(2) / 100}
                      {/* <span className='product-card__old-price'>$23</span> */}
                    </h1>
                    <ProductTabs product={currentProduct} />
                  </div>
                </div>
              </CardBody>
            </Card>
            : null
        }
      </Col>
    )
  }
}
function mapStateToProps(state) {
  return {
    cartItems: state.cartData.items
  }
}
export default withRouter(withApollo(connect(mapStateToProps, { addItem })(ProductCard)));



// WEBPACK FOOTER //
// ./src/components/e-commerce/product_page/components/ProductCard.js